import { IDbEntity } from "./IDbEntity";

export interface IDigitalSignatureRequest extends IDbEntity {
  status: DigitalSignatureRequestStatuses;
  email: string;
  confirmedAt?: string;
  authorizedSignatoryId: number;
  signedAt?: string;
  token?: string;
  documentId: number;
  createdById: number;
}

export enum DigitalSignatureRequestStatuses {
  PENDING = "pending",
  CONFIRMED = "confirmed",
  SIGNED = "signed",
}

export interface CreateDigitalSignatureRequestDTO {
  email: string;
  authorizedSignatory: number;
  documentId: number;
  sendEmailToCustomer: boolean;
}
